import React, { useState } from "react";
import { useFirebase } from "../../database/FirebaseContext";

const MemberForm = ({ onClose }) => {
	const { addUser } = useFirebase();

	const [formMember, setFormMember] = useState({
		userName: "",
		userEmail: "",
		userPassword: "",
		userRole: "Member",
		userWorkingHours: 0,
	});

	const handleEvent = (event) => {
		const { name, value } = event.target;
		setFormMember((prevMember) => {
			return {
				...prevMember,
				[name]: value,
			};
		});
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		addUser(formMember);
	};
	return (
		<div className="fixed block z-[1] w-full h-full overflow-auto bg-[rgba(0,0,0,0.649)] top-0 left-0 ">
			<div className="flex justify-center items-center mt-[30vh] ml-[50vh]">
				<div className="text-[#ffffff] w-5/12 h-auto bg-[#3D3E44] rounded-xl ">
					{/* Header for Form */}
					<div className="bg-[#9B9B9B] rounded-t-xl py-3 text-3xl text-center">
						Add Member
					</div>

					{/* Form */}
					<div className="bg-[#3D3E44] rounded-b-xl">
						<form onSubmit={handleSubmit}>
							<div className="bg-modalbg flex mt-[35px]">
								<div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[50px]">
									<label htmlFor="userName">
										<p className="text-[14px]">Name</p>
									</label>
								</div>
								<div className="bg-fieldbg flex shrink-10 items-center w-full mr-[15px]">
									<input
										className="pl-[5px] text-[12px] bg-fieldbg w-full text-black"
										type="text"
										id="userName"
										name="userName"
										value={formMember.userName || ""}
										onChange={handleEvent}
										required
									/>
								</div>
							</div>

							<div className="bg-modalbg flex mt-[20px]">
								<div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[54px]">
									<label htmlFor="userEmail">
										<p className="text-[14px]">Email</p>
									</label>
								</div>
								<div className="bg-fieldbg flex shrink-10 items-center w-full mr-[15px]">
									<input
										className="pl-[5px] text-[12px] bg-fieldbg w-full text-black"
										type="text"
										id="userEmail"
										name="userEmail"
										value={formMember.userEmail || ""}
										onChange={handleEvent}
										required
									/>
								</div>
							</div>

							<div className="bg-modalbg flex mt-[20px]">
								<div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[28px]">
									<label htmlFor="userPassword">
										<p className="text-[14px]">Password</p>
									</label>
								</div>
								<div className="bg-fieldbg flex shrink-10 items-center w-full mr-[15px]">
									<input
										className="pl-[5px] text-[12px] bg-fieldbg w-full text-black"
										type="text"
										id="userPassword"
										name="userPassword"
										value={formMember.userPassword || ""}
										onChange={handleEvent}
										required
									/>
								</div>
							</div>

							{/* Buttons */}
							<div className="bg-modalbg flex mt-[25px] justify-center mb-[20px]">
								<div className="space-x-5">
									<button
										type="submit"
										value="save"
										className="bg-[#616675] text-center px-3 py-1 rounded-lg text-xl"
									>
										SAVE
									</button>
									<button
										className="bg-[#616675] text-center px-3 py-1 rounded-lg text-xl"
										onClick={onClose}
									>
										CLOSE
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MemberForm;
